import { useEffect, useRef } from "react";

export const useDebounceEffect = (
  effect: () => void,
  delay: number | undefined,
  deps: unknown[]
) => {
  const effectRef = useRef(effect);
  effectRef.current = effect;

  useEffect(() => {
    if (!delay) {
      effectRef.current();
      return;
    }

    const handler = setTimeout(() => {
      effectRef.current();
    }, delay);

    return () => {
      clearTimeout(handler);
    };
    // deps is dynamic, so the rule cannot verify it statically.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps, delay]);
};
